var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlert({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14.49 13.14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.2,9.87L9.14,1.1c-.39-.69-1.1-1.1-1.89-1.1s-1.5,.41-1.89,1.09L.29,9.87c-.39,.69-.39,1.5,0,2.19,.39,.68,1.1,1.08,1.88,1.08H12.3c.79,0,1.5-.41,1.9-1.1,.4-.69,.4-1.5,0-2.17Zm-1.13,1.52c-.17,.29-.45,.45-.77,.45H2.18c-.32,0-.6-.16-.76-.43-.16-.28-.17-.61,0-.89L6.49,1.74c.16-.28,.44-.44,.76-.44s.6,.16,.76,.44l5.07,8.78c.16,.27,.15,.59,0,.87Zm-5.03-1.08c.02,.42-.37,.79-.79,.79s-.81-.37-.81-.81,.37-.81,.81-.81,.81,.37,.79,.83Zm-.05-6.05c.05,.13,.07,.26,.07,.4-.02,.4-.06,.81-.07,1.21-.04,.62-.07,1.25-.11,1.87-.02,.2-.02,.39-.02,.59-.02,.33-.27,.59-.6,.59s-.59-.24-.6-.57c-.05-.97-.11-1.93-.17-2.9-.02-.26-.04-.51-.05-.77,0-.42,.24-.77,.62-.88,.07-.02,.13-.02,.2-.02,.31,0,.6,.18,.74,.48Z",
    fill: "#d163ab"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.e91d7edcfd892247fa9ab2c755c822f6.svg";
export { ForwardRef as ReactComponent };